import { ComponentProps, ReactElement } from 'react';
import { Link } from 'react-router';
import { AppTo } from '../../../routes';

type AppLinkProps = Omit<ComponentProps<typeof Link>, 'to'> & { to: AppTo };

/** Wrapper de `Link` que restringe `to` a `AppTo`, evitando rota solta que não exista em `PATHS`. */
export const AppLink = ({ to, ...props }: AppLinkProps): ReactElement => (
  <Link to={to} {...props} />
);
